var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show && _vm.actions && _vm.actions.length,
          expression: "show && actions && actions.length"
        },
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "v-context",
      style: _vm.style,
      attrs: { tabindex: "-1" },
      on: {
        click: _vm.onClick,
        "!contextmenu": function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c(
        "ul",
        { staticClass: "v-context-list" },
        _vm._l(_vm.actions, function(action) {
          return !action.hidden
            ? _c(
                "li",
                {
                  staticClass: "v-context-list-item",
                  class: { disabled: action.disabled },
                  on: {
                    click: function($event) {
                      return _vm.click(action.name, _vm.data)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "v-context-icon" }, [
                    _c("i", {
                      staticClass: "fas",
                      class: "fa-" + (action.icon || "arrow-right")
                    }),
                    _vm._v(" "),
                    action["additionalIcon"]
                      ? _c(
                          "span",
                          { staticClass: "v-context-additional-icon" },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class:
                                "fa-" + (action.additionalIcon || "arrow-right")
                            })
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "v-context-text" }, [
                    _vm._v(_vm._s(action.title))
                  ])
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default", null, { data: _vm.data })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }